package com.eladfinish.bible.contest.screens.settings.debug

import com.russhwolf.settings.Settings

data class DebugFlagState(
    val flag: DebugFlag,
    val value: Boolean,
    /** False while the key was never written, i.e. the app is running on the default. */
    val isStored: Boolean,
)

class DebugFlagsRepository(
    private val settings: Settings,
    private val flags: List<DebugFlag> = debugFlags,
) {

    /**
     * In [DebugFlagGroup] order, and alphabetically by key (the text the screen shows) inside each
     * group, so a flag added anywhere in [debugFlags] lands in its place.
     */
    fun states(): List<DebugFlagState> =
        flags.sortedWith(displayOrder).map { flag ->
            val isStored = settings.hasKey(flag.key)

            DebugFlagState(
                flag = flag,
                value = if (isStored) settings.getBoolean(flag.key, flag.defaultValue) else flag.defaultValue,
                isStored = isStored,
            )
        }

    fun set(flag: DebugFlag, value: Boolean) {
        settings.putBoolean(flag.key, value)
    }

    /** Back to "never written", as on a fresh install. */
    fun reset(flag: DebugFlag) {
        settings.remove(flag.key)
    }

    private companion object {
        val displayOrder: Comparator<DebugFlag> =
            compareBy<DebugFlag> { it.group }.thenBy(String.CASE_INSENSITIVE_ORDER) { it.key }
    }
}
